export const ERROR = "ERROR";
export const DRAWER_MENU = "DRAWER_MENU";
export const AUTH_DIALOG = "AUTH_DIALOG";
export const COVERAGE_DIALOG = "COVERAGE_DIALOG";
export const LOCATION_DIALOG = "LOCATION_DIALOG";
export const SET_ADDRESS = "SET_ADDRESS";
export const SET_USER = "SET_USER";
export const SET_CARTS = "SET_CARTS";
export const ADD_CART = "ADD_CART";
export const IS_SEARCHING = "IS_SEARCHING";
export const SET_NAVBAR_HOME_FOOTER = "SET_NAVBAR_HOME_FOOTER";
export const SET_NAVBAR_OFERTAS_FOOTER = "SET_NAVBAR_OFERTAS_FOOTER";
export const SET_NAVBAR_CARRITO_FOOTER = "SET_NAVBAR_CARRITO_FOOTER";
export const SET_NAVBAR_MENU_FOOTER = "SET_NAVBAR_MENU_FOOTER";
export const MY_ACCOUNT = "MY_ACCOUNT";
